module.exports = __webpack_public_path__ + "static/media/burger2.279d3b38.png";